/**
 * Legacy named label colors → hex. Includes project type/source/stage palette + tag extras.
 * Purple resolves to true purple (not gray / brand tint).
 */
export const LEGACY_LABEL_COLOR_HEX: Record<string, string> = {
  blue: '#2563EB',
  green: '#16A34A',
  purple: '#7C3AED',
  orange: '#EA580C',
  red: '#DC2626',
  yellow: '#CA8A04',
  indigo: '#4F46E5',
  pink: '#DB2777',
  gray: '#64748B',
  grey: '#64748B',
  // Tag extras
  teal: '#0D9488',
  cyan: '#0891B2',
  lime: '#65A30D',
  amber: '#D97706',
  emerald: '#059669',
  violet: '#7C3AED',
  rose: '#E11D48',
  fuchsia: '#C026D3',
  sky: '#0284C7',
  slate: '#475569',
};

export const LEGACY_LABEL_COLOR_NAMES = Object.keys(LEGACY_LABEL_COLOR_HEX);

export const DEFAULT_LABEL_COLOR_HEX = '#64748B';
